import React from 'react';
import { ExperienceType } from '../../../../enums/experience';
import { useGetAllAssetsQuery } from '../../../../../app/Slices/SevenDayApiSlice';
import {
    Avatar,
    Button,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    Typography,
} from '@mui/material';
import { useFormState } from '../../Form/useFormState';
import { Experience } from '../../../../types/experience';

const AddOnsSection = () => {
    const { experience } = useFormState();
    const { data } = useGetAllAssetsQuery({
        url: `/modules`,
        type: [ExperienceType.Activity, ExperienceType.Vehicle],
    });

    const experiences: Experience[] =
        data?.filter((asset: Experience) =>
            experience.addOns.find((addOn) => addOn.id === asset.id),
        ) ?? [];

    const handleManage = (experience: Experience) => {
        window.open(
            `/experiences/edit/${experience.id}`,
            '_blank',
            'noopener,noreferrer',
        );
    };

    return (
        <div>
            <Typography
                component='h4'
                sx={{ color: 'text.primary', fontWeight: 'bold' }}
            >
                Add-ons
            </Typography>
            <Typography variant='body2' color='text.secondary'>
                Connect activities and vehicles you own on this platform so
                guests can book them alongside this experience.
            </Typography>
            {experiences.length > 0 && (
                <Paper sx={{ my: 2 }}>
                    <List>
                        {experiences.map((experience) => (
                            <ListItem key={experience.id}>
                                <ListItemAvatar>
                                    <Avatar
                                        variant='rounded'
                                        src={experience.photos[0].src}
                                    />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={experience.name}
                                    secondary={`${experience.suburb}, ${experience.state}`}
                                />
                                <ListItemSecondaryAction>
                                    <Button
                                        variant='outlined'
                                        onClick={() => handleManage(experience)}
                                    >
                                        Manage
                                    </Button>
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                </Paper>
            )}
            <Typography variant='body2'>
                To add or manage add-ons, see the availability mode section of
                your vehicles and activites
            </Typography>
        </div>
    );
};

export default AddOnsSection;
